import React, {Component} from 'react';
import {connect} from 'react-redux';
import {withRouter} from 'react-router-dom';
import ConsoleSidebar from './ConsoleSidebar';
import SidebarLink from './SidebarLink';

import KPI from './kpi';
import Countries from './countries';
import Demographics from './Demographics';
import Browsers from './Browsers';
import Flags from './Panels/Flags';
import TableView from './TableView';
import Engagement from './Engagement';
import Students from './Students/Students';
import Comments from './Panels/Comments';
import * as AppActions from "../../store/actions/appActions";

class AdminConsole extends Component {
    renderTabs = () => {
        let views = [
            {view: 'flags', title: 'Red Flags'},
            {view: 'subject_failure', title: 'Subject Failure'},
            {view: 'lecture_failure', title: 'Lecture Failure'},
            {view: 'upcoming_tests', title: 'Upcoming Tests'},
            {view: 'attendance', title: 'Attendance'},
            {view: 'quiz_average', title: 'Quiz Average'},
        ]
        return (
            <div className="chat-head no-padding" style={{marginLeft: '240px'}}>
                <div className="">
                    <ul className="header-nav">
                        {views.map(v => {
                            return (
                                <li className={`${this.props.match.params.view === v.view ? 'active' : ''}`}>
                                    <SidebarLink view={v.view} title={v.title} />
                                </li>
                            )
                        })}
                    </ul>
                </div>
            </div>
        )
    }

    componentDidMount(){
        this.props.hideLoader();
    }

    componentDidUpdate(props) {
        if (!this.props.match.params.courseId && this.props.adminCourses.length > 0) {
            if (this.props.match.params.view) {
                if (this.props.match.params.view !== "undefined"){
                    this.props.history.push(`/admin/${this.props.adminCourses[0].id}/${this.props.match.params.view}`)
                } else {
                    this.props.history.push(`/admin/${this.props.adminCourses[0].id}/analytics`)
                }
            }else {
                this.props.history.push(`/admin/${this.props.adminCourses[0].id}/analytics`)
            }
        }
    }

    render(){
        const tabbedViews = ["flags", "subject_failure", "lecture_failure", "upcoming_tests", "attendance", "quiz_average"];
        let showTabs = tabbedViews.indexOf(this.props.match.params.view) > -1;
        return (
            <div className="content-wrapper" id="content-container">
                <section className="content no-padding">
                    <div className="admin-dashboard-wrap">
                        <ConsoleSidebar />
                        <div className="dashboard-content">
                            {showTabs ? 
                                this.renderTabs()
                            : 
                                <h3 className="font-300 font-24 text-white sm-bottom30 sm-top0 capitalize">{this.props.match.params.view || 'Analytics'} | &nbsp;
                                    {
                                        this.props.match.params.courseId && this.props.adminCourses ?
                                            this.props.adminCourses.filter(c => c.id === this.props.match.params.courseId)[0] ? 
                                            this.props.adminCourses.filter(c => c.id === this.props.match.params.courseId)[0].name
                                                : 'All Courses'
                                            : 'All Courses'
                                        }
                                </h3>
                            }

                            {!this.props.match.params.view || this.props.match.params.view === 'analytics' ?
                                <div className="dd" id="nestable3">
                                    <ol className="dd-list">
                                        <KPI />
                                        <Countries />
                                        <Demographics />
                                    </ol>
                                </div>
                                
                            : null}

                            {this.props.match.params.view === 'students' ?
                                <Students socket={this.props.socket} />
                            : null}

                            {this.props.match.params.view === 'engagement' ?
                                <Engagement />
                            : null}

                            {this.props.match.params.view === 'flags' ?
                                <TableView view={this.props.match.params.view} />
                            : null}

                            {this.props.match.params.view === 'subject_failure' ?
                                <TableView view={this.props.match.params.view} />
                            : null}

                            {this.props.match.params.view === 'lecture_failure' ?
                                <TableView view={this.props.match.params.view} />
                            : null}

                            {this.props.match.params.view === 'upcoming_tests' ?
                                <TableView view={this.props.match.params.view} />
                            : null}

                            {this.props.match.params.view === 'attendance' ?
                                <TableView view={this.props.match.params.view} />
                            : null}

                            {this.props.match.params.view === 'quiz_average' ?
                                <TableView view={this.props.match.params.view} />
                            : null}

                            {this.props.match.params.view === 'comments' ?
                                <Comments />
                            : null}
                        </div>
                    </div>
                    
                </section>
            </div>
            
        )
    }
}

const mapStateToProps = state => ({
    ...state.auth,
    ...state.adminInfo
});

const mapDispatchToProps = dispatch => ({
    hideLoader: () => {
        dispatch(AppActions.appLoading(false));
    }
});

export default connect(
    mapStateToProps,
    mapDispatchToProps
)(withRouter(AdminConsole));



// WEBPACK FOOTER //
// ./src/components/AdminConsole/AdminConsole.js